
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/haber/[id]",
      function () {
        return require("private-next-pages/haber/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/haber/[id]"])
      });
    }
  